import { FC } from 'react';

import AccordionCard from 'components/Tables/PricingV2/components/AccordionCard';
import { PricingTableConfigProps } from 'components/Tables/PricingV2/config';

const MobileTable: FC<PricingTableConfigProps> = ({
  tierOneTitle,
  tierOneLabel,
  tierOneLink,
  tierOneStartIcon,
  tierOneEndIcon,
  tierOneDescription,
  tierOneHighlighted,
  tierOneChiliPiperUrl,
  tierTwoTitle,
  tierTwoLabel,
  tierTwoLink,
  tierTwoStartIcon,
  tierTwoEndIcon,
  tierTwoDescription,
  tierTwoHighlighted,
  tierTwoChiliPiperUrl,
  tierThreeTitle,
  tierThreeLabel,
  tierThreeLink,
  tierThreeStartIcon,
  tierThreeEndIcon,
  tierThreeDescription,
  tierThreeHighlighted,
  tierThreeChiliPiperUrl,
  tableSections,
}) => (
  <div className="flex flex-col items-center gap-2.5 lg:hidden">
    <AccordionCard
      label={tierOneTitle}
      buttonLabel={tierOneLabel}
      link={tierOneLink}
      startIcon={tierOneStartIcon}
      endIcon={tierOneEndIcon}
      description={tierOneDescription}
      tableSections={tableSections}
      isHighlighted={tierOneHighlighted}
      chiliPiperUrl={tierOneChiliPiperUrl}
      node="tierOne"
    />
    <AccordionCard
      label={tierTwoTitle}
      buttonLabel={tierTwoLabel}
      link={tierTwoLink}
      startIcon={tierTwoStartIcon}
      endIcon={tierTwoEndIcon}
      description={tierTwoDescription}
      tableSections={tableSections}
      isHighlighted={tierTwoHighlighted}
      chiliPiperUrl={tierTwoChiliPiperUrl}
      node="tierTwo"
    />
    <AccordionCard
      label={tierThreeTitle}
      buttonLabel={tierThreeLabel}
      link={tierThreeLink}
      startIcon={tierThreeStartIcon}
      endIcon={tierThreeEndIcon}
      description={tierThreeDescription}
      tableSections={tableSections}
      isHighlighted={tierThreeHighlighted}
      chiliPiperUrl={tierThreeChiliPiperUrl}
      node="tierThree"
    />
  </div>
);

export default MobileTable;
